<div class="auth-layout-wrap"
    style="background-image: url(./assets/images/auth-bg.jpg)">
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
</div>